module.exports = __webpack_public_path__ + "media/images/logo_en-35c33e23cd96c99755d4e633f1616849.svg";